import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Use Bootstrap's modal API if available
    if (window.bootstrap && window.bootstrap.Modal) {
      // Get or create modal instance
      this.modalInstance = bootstrap.Modal.getOrCreateInstance(this.element);
      
      // Show the modal using Bootstrap's API
      this.modalInstance.show();
      
      // Store bound function reference for proper cleanup
      this.boundHandleHidden = this.handleHidden.bind(this);
      // Add event listener for when modal is hidden
      this.element.addEventListener('hidden.bs.modal', this.boundHandleHidden);
    } else {
      // Fallback: Add event listeners to close buttons
      const closeButtons = this.element.querySelectorAll('.btn-close, button[data-bs-dismiss="modal"]');
      this.boundClose = this.close.bind(this);
      closeButtons.forEach(button => {
        button.addEventListener('click', this.boundClose);
      });

      // Store bound function reference for proper cleanup
      this.boundHandleKeyDown = this.handleKeyDown.bind(this);
      document.addEventListener('keydown', this.boundHandleKeyDown);
      
      // Add backdrop
      this.addBackdrop();
    }
  }
  
  disconnect() {
    if (this.modalInstance) {
      // Remove event listener using stored reference
      if (this.boundHandleHidden) {
        this.element.removeEventListener('hidden.bs.modal', this.boundHandleHidden);
      }
      // Dispose of modal instance
      this.modalInstance.dispose();
    } else {
      // Remove event listeners using stored references
      if (this.boundHandleKeyDown) {
        document.removeEventListener('keydown', this.boundHandleKeyDown);
      }
      if (this.boundClose) {
        const closeButtons = this.element.querySelectorAll('.btn-close, button[data-bs-dismiss="modal"]');
        closeButtons.forEach(button => {
          button.removeEventListener('click', this.boundClose);
        });
      }
      this.removeBackdrop();
    }
  }
  
  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
  
  handleHidden() {
    // Handle modal hidden event
    this.close();
  }
  
  close() {
    // Redirect to the appropriate page using the data attribute
    const returnUrl = this.element.dataset.returnUrl;
    if (returnUrl) {
      window.location.href = returnUrl;
    } else {
      window.history.back();
    }
  }
  
  addBackdrop() {
    if (!document.querySelector('.modal-backdrop')) {
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      document.body.appendChild(backdrop);
      document.body.classList.add('modal-open');
    }
  }
  
  removeBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
      document.body.classList.remove('modal-open');
    }
  }
}